module.exports = __webpack_public_path__ + "static/img/mowpi-dashboard-2.0892751.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mowpi-dashboard-2.jpg
// module id = qWG2
// module chunks = 1